<template>
  <footer class="mobile-footer">
    <div class="footer-content">
      <div>
        <section
         
          class="top-navbar"
          id="topBarHeader"
          :style="`background: ${loginPageColor} !important;`"
        >
          <el-row type="flex" align="middle" class="topbar-appearence">
            <el-col :md="24">
              <div class="footer-bar-container">
                <ul class="logout-dropdown">
                   <li>
    <div class="icon-wrapper" @click="$router.push('/dashboard')">
      <div class="icon-block">
        <i class="fa fa-home icon"></i>
      </div>
      <span class="icon-label">Dashboard</span>
    </div>
  </li>
                  <li class="logout-list-menu">
                    <div
                      class="notification-wrapper"
                      @click="toggleAppNotificationPopup"
                    >
                      <div class="icon-block">
                        <i class="fa fa-bell icon"></i>
                        <span
                          v-if="totalUnreadNotificationsCount > 0"
                          class="badge-notification"
                        >
                          {{ totalUnreadNotificationsCount }}
                        </span>
                      </div>
                      <span class="icon-label">Notifications</span>
                    </div>

                    <div
                      :class="[
                        'notification-popup',
                        getIsMobile ? 'mobile-column' : 'notification-popup2',
                      ]"
                      v-if="isAppNotificationPopupShow"
                      v-click-outside="hideAppNotificationPopup"
                    >
                      <div class="popup-header">
                        <span>Notifications</span>
                        <button
                          class="close-btn"
                          @click="hideAppNotificationPopup"
                        >
                          ×
                        </button>
                      </div>
                      <el-scrollbar
                        style="
                          overflow-y: auto;
                          height: calc(100vh - 60px);
                          margin-top: 50px;
                        "
                      >
                        <ul class="list-group list-group-flush">
                          <li class="notifications-top-row first-row-select">
                            <div
                              style="
                                display: flex;
                                align-items: center;
                                width: 100%;
                                margin-top: 2%;
                                padding: 1%;
                              "
                            >
                              <select
                                class="form-select form-select-sm"
                                v-model="selectedNotificationType"
                                @change="fetchAppNotifications"
                                style="margin-right: 1%; flex: 1"
                              >
                                <option
                                  v-for="e in appNotificationTypes"
                                  :key="e.value"
                                  :value="e.value"
                                >
                                  {{ e.name }}
                                </option>
                              </select>
                              <el-input
                                size="mini"
                                placeholder="Search"
                                v-model="notification_search_string"
                                clearable
                                style="flex: 1"
                              ></el-input>
                            </div>
                          </li>
                          <div class="notification-count">
                            Notifications ({{
                              unreadNotificationsCount || 0
                            }}/{{ allNotificationsCount }})
                          </div>
                          <li class="notifications-footer">
                            <div class="footer-actions">
                              <a
                                @click="markAppNotificationsAsReadChats"
                                class="mark-read-link"
                              >
                                Mark all as read
                              </a>
                              <el-tooltip
                                :content="
                                  isUnreadOnly === 'ALL'
                                    ? 'Show unread only'
                                    : 'Show all'
                                "
                                placement="top"
                              >
                                <el-switch
                                  v-model="isUnreadOnly"
                                  active-color="#13ce66"
                                  inactive-color="#ff4949"
                                  active-value="UNREAD"
                                  inactive-value="ALL"
                                  @change="fetchAppNotifications"
                                />
                              </el-tooltip>
                            </div>
                          </li>
                          <li
                            v-for="(item, index) in allAppNotifications"
                            :key="index + '_notification'"
                            class="list-group-item notifcation-item"
                            @click="handleNotificationClick(item)"
                          >
                            <div class="item-avatar" v-if="!getIsMobile">
                              {{ getNotificationTypeAvatar(item.type) }}
                            </div>
                            <div class="item-body">
                              <div class="notification-line">
                                <span
                                  class="message"
                                  v-html="getNotificationMessageWithDate(item)"
                                ></span>
                              </div>
                            </div>
                          </li>
                          <li
                            class="load-more-element"
                            v-if="allNotificationsCount > totalPageLogs"
                            @click="loadMoreLogs"
                            v-loading="LoadMoreLoading"
                          >
                            <div class="load-more">
                              <a>Load More...</a>
                            </div>
                          </li>
                          <li
                            v-if="
                              allAppNotifications && !allAppNotifications.length
                            "
                            class="list-group-item notifcation-item"
                          >
                            <div class="item-avatar">ND</div>
                            <div class="item-body">
                              <p class="mb-0 text-secondary">
                                You have no notifications to show
                              </p>
                              <span class="date-time">-</span>
                            </div>
                          </li>
                        </ul>
                      </el-scrollbar>
                    </div>
                  </li>

                  <!-- 
  <li>
                    <div class="icon-wrapper toggle-menu-animation" @click="toggleMenuPopup">
                      <div
                        v-if="isHorMenu"
                        id="burger"
                        :class="getIsOpen ? 'active' : ''"
                        
                      >
                        <button type="button" class="circle-outline-hamburger">
                          <span class="burger-bar burger-bar--1"></span>
                          <span class="burger-bar burger-bar--2"></span>
                          <span class="burger-bar burger-bar--3"></span>
                        </button>
                      </div>
                      <span class="icon-label">Menu</span>
                    </div>
                  </li> -->

                  <!-- <li>
                    <div
                      class="icon-wrapper toggle-menu-animation"
                      @click="toggleMenuPopup"
                    >
                      <div
                        v-if="isHorMenu"
                        id="burger"
                        :class="getIsOpen ? 'active' : ''"
                      >
                        <button type="button" class="circle-outline-hamburger">
                          <span class="burger-bar burger-bar--1"></span>
                          <span class="burger-bar burger-bar--2"></span>
                          <span class="burger-bar burger-bar--3"></span>
                        </button>
                      </div>
                      <span class="icon-label">Menu</span>
                    </div>
                  </li> -->

                  <!-- 
                  <li class="logout-list-menu" v-if="getIsMobile">
  <InternalChat />
   <div class="icon-block">
                        <i class="fa fa-comments icon"></i>
                      </div>
                      <span class="icon-label">Chat</span>
</li> -->
                <li class="logout-list-menu" v-if="getIsMobile ">
                    <InternalChat v-if="getAuthenticatedUser && getStatusOfInternalChat && showChat" />
  <!-- <InternalChat ref="internalChat" :hide-icon="true" /> -->
</li>


<li class="logout-list-menu" tabindex="-1" @click="$router.push('/entity')" v-if="isWorkspaceIsBusiness">
  <div class="icon-wrapper">
    <div class="icon-block">
      <i class="fa fa-database icon"></i>
    </div>
    <span class="icon-label">Entities</span>
  </div>
</li>
                </ul>
              </div>
            </el-col>
          </el-row>
        </section>
      </div>
    </div>
  </footer>
</template>

<!-- <script>
export default {
  name: 'MobileFooter',
};
</script> -->

<script>
import { bus } from "../main";
import { mapGetters, mapActions } from "vuex";
import axios from "@/config/axios";
// import ViewAllNotifications from "../components/notifications/ViewAllNotifications";
// import ViewAllChats from "../components/notifications/ViewAllChats";
import PermissionsHelper from "@/mixins/permissionsHelper";
import Swal from "sweetalert2";
import appConfig from "@/config/app";
import moment from "moment";
import authHelper from "@/mixins/authHelper";
import { postAPICall } from "@/helpers/httpHelper";
import { fetchUserTypes } from "@/repo/commonApiRepo";
import AccessManagement from "@/mixins/AccessManagement";
import InternalChat from "@/components/InternalChat.vue";
import AppConfiguration from "../config/app";

export default {
  name: "MobileFooter",
  components: {
    InternalChat,
  },

  mixins: [PermissionsHelper, authHelper, AccessManagement],
  data() {
    return {
       appSettings : AppConfiguration,
   
      lastSelectedWorkspaceId: null,
      showWorkspaceDropdown: false,
      showRoleDropdown: false,
      showGlobalFilterDropdown: false,
      loadingText: "Gathering your workspace resources, please wait...",
      events: [
        "keyup",
        "keypress",
        "keydown",
        "click",
        "contextmenu",
        "dbclick",
        "mousedown",
        "mouseenter",
        "mouseleave",
        "mousemove",
        "mouseout",
        "mouseover",
        "mouseup",
        "error",
        "loadstart",
        "touchcancel",
        "touchend",
        "touchmove",
        "touchstart",
        "select",
        "unload",
        "scroll",
        "resize",
        "load",
        "beforeunload",
        "abort",
        "wheel",
      ],
      res: [],
      title: "",
      isOpen: false,
      isCollapse: "",
      routerValue: "",
      offCanvas: "",
      documentLogs: [],
      openProfile: false,
      isNotificationPopupShow: false,
      isAppNotificationPopupShow: false,
      selectedNotificationType: "ALL",
      appNotificationTypes: [
        {
          name: "All",
          value: "ALL",
        },
        {
          name: "Entity",
          value: "ENTITY",
        },
        {
          name: "Form Builder",
          value: "FORM_BUILDER",
        },
        {
          name: "Email",
          value: "NOTIFICATION",
        },
        {
          name: "Others",
          value: "OTHERS",
        },
      ],
      isViewAllNotificationsPopupShow: false,
      isUnreadOnly: "",
      isViewAllAppNotificationsPopupShow: false,
      notification_search_string: "",
      appNotificationsLoading: false,
      allAppNotifications: null,
      isChatPopupShow: false,
      unreadNotificationsCount: null,
      totalNotificationsCount: null,
      allNotificationsCount: null,
      totalUnreadNotificationsCount: null,
      isViewAllChatsPopupShow: false,
      LoadMoreLoading: false,
      totalPageLogs: 0,
      isExist: false,
      selectLoad: false,
      permissionsList: [],
      loading: false,
      isLoading: false,
      fullPage: true,
      canCancel: true,
      useSlot: false,
      loader: "spinner",
      color: "#F754A2",
      bgColor: "#b0aeae",
      height: 64,
      width: 64,
      timeout: 15000, //ms
      opacity: 0.7,
      assignedRoles: [],
      baseURL: window.location.origin + "/signin",
      serverBaseURL: appConfig.AUTHFAST_BASE_URL,
      planDetails: {},
      loginPageColor: "#1B487E",
      isHorMenu: true,
      globalFilter: "",
      appSetting: {},
      logo: null,
      notificationsPageSize: 10,
      notificationsPage: 1,
      userTypes: [],
      botId: "",
      token: "",
    };
  },
  computed: {
    ...mapGetters("userStatus", [
      "getNotificationCountUnOpened",
      "getChatCountUnOpened",
    ]),
    ...mapGetters("navigationOpen", ["getIsMobile", "getIsOpen"]),
    ...mapGetters("auth", [
      "getAuthenticatedUser",
      "getActiveWorkspace",
      "getAuthenticationStatus",
      "getWorkspaceList",
      "getUserType",
      "getSwitchWorkspaceError",
      "getPermissionList",
      "getPermissions",
      "getGlobalFiltervalue",
      "getAuthenticationDetails",
      "getUserTypeList",
      "getUserTypeEmailsErrors",
      "getUserTypeEmails",
      "getDefaultDateFormat",
    ]),
    ...mapGetters("dashboard", [
      "getNotifications",
      "getChats",
      "getNotificationsUnReadCnt",
      "getChatsUnReadCnt",
    ]),
    ...mapGetters("company", [
      "getCompanyDetails",
      "getUpdateCompany",
      "getCompanyLogo",
      "getSingleCompanyLogo",
      "getContactLoginSlug",
    ]),
    ...mapGetters("paymentGateway", ["getPaymentsHistory", "getPlansFeatures"]),
    ...mapGetters("menuManagementV2", ["getMenu"]),
    ...mapGetters("entities", ["getEntityRecordsForTable"]),
    ...mapGetters("appNotifications", [
      "getAllAppNotifications",
      "getAppNotificationErrors",
      "getMarkAllAsReadStatus",
    ]),
    ...mapGetters("UserIntegrations", ["getIntegrationsList"]),
     getStatusOfInternalChat()
    {
      return this.appSettings?.isShowInternalChat? this.appSettings.isShowInternalChat : false;
    },
    showChat() {
      return this.$route.matched.some(r => r.meta.showChat)
    }
  },
  async mounted() {
    this.loading = true;
    this.appSetting = appConfig;
    // let id =
    //   this.getActiveWorkspace &&
    //     this.getActiveWorkspace.company_id &&
    //     this.getActiveWorkspace.company_id._id
    //     ? this.getActiveWorkspace.company_id._id
    //     : this.getActiveWorkspace.company_id;
    await Promise.all([
      this.getBotAccounts(),
      this.getCompanyConfigurationsList(),
      // this.$store.dispatch("company/fetchCompany", id),
      // this.$store.dispatch("company/fetchCompanyLogo", id),
    ]);
    this.loading = false;
    document.addEventListener("click", this.handleClickOutside);
    try {
      if (this.getAuthenticatedUser && this.getAuthenticatedUser.contact_type) {
        await this.handleLogoutInfo();
        
      } else {
        await this.getNecessaryInfo();
      }
    } catch (error) {
      console.log("error", error);
    }
  },
  watch: {
    $route({ meta }) {
      this.title = meta.title || "Dashboard";
    },
    permissionsList: async function () {
      if (this.permissionsList) {
        const permissionsData = await Promise.all(
          this.permissionsList.map(async (cat) => {
            const permissions = await Promise.all(
              cat.permissions.map((item) => item.slug)
            );
            return permissions;
          })
        );
        const permissionSet = permissionsData.flat();
        await this.$store.dispatch("auth/CompanyPermissionSet", permissionSet);
      }
    },
    getPaymentsHistory: async function () {
      this.setPaymentsHistory();
    },
    getSingleCompanyLogo: async function () {
      if (this.getSingleCompanyLogo) {
        this.logo = `${appConfig.S3_BUCKET_URL}/${this.getSingleCompanyLogo}`;
      }
    },
    notification_search_string: {
      handler: function () {
        this.fetchAppNotifications();
      },
      deep: true,
    },
  },
  methods: {
    toggleMenuPopup() {
      this.$store.commit("navigationOpen/setIsOpen", !this.getIsOpen, {
        root: true,
      });
      this.isAppNotificationPopupShow = false;
    },
    getNotificationMessageWithDate(item) {
      const message = this.getAppNotificationDescription(item);
      const date = this.$options.filters.getFormattedDateTypeThree(
        item.created_at
      );
      return `${message} <small class='date-time'>(${date})</small>`;
    },

    handleOutsideClick(event) {
      if (!this.getIsMobile) return;
      const wsRef = this.$refs.workspaceDropdown;
      const roleRef = this.$refs.roleDropdown;
      const gfRef = this.$refs.globalFilterDropdown;
      const clickedOutsideWorkspace = wsRef && !wsRef.contains(event.target);
      const clickedOutsideRole = roleRef && !roleRef.contains(event.target);
      const clickedOutsideGlobalFilter = gfRef && !gfRef.contains(event.target);
      if (this.showWorkspaceDropdown && clickedOutsideWorkspace) {
        this.showWorkspaceDropdown = false;
      }
      if (this.showRoleDropdown && clickedOutsideRole) {
        this.showRoleDropdown = false;
      }
      if (this.showGlobalFilterDropdown && clickedOutsideGlobalFilter) {
        this.showGlobalFilterDropdown = false;
        this.isAppNotificationPopupShow = false;
      }
    },
    toggleWorkspaceDropdown() {
      this.showWorkspaceDropdown = !this.showWorkspaceDropdown;
      this.showRoleDropdown = false;
      this.showGlobalFilterDropdown = false;
      this.isAppNotificationPopupShow = false;
    },
    selectWorkspace(company) {
      const val = company.company_id._id;
      this.currentWorkspaceId = val;
      this.onWorkspaceChange(val);
      this.showWorkspaceDropdown = false;
    },
    toggleRoleDropdown() {
      this.showRoleDropdown = !this.showRoleDropdown;
      this.showGlobalFilterDropdown = false;
      this.showWorkspaceDropdown = false;
      this.isAppNotificationPopupShow = false;
    },
    selectRole(role) {
      const val = role.userType_id;
      this.activeRole = val;
      this.changeRole();
      this.showRoleDropdown = false;
    },
    toggleGlobalFilterDropdown() {
      this.showGlobalFilterDropdown = !this.showGlobalFilterDropdown;
      this.showRoleDropdown = false;
      this.isAppNotificationPopupShow = false;
      this.showWorkspaceDropdown = false;
    },
    selectGlobalFilter(data) {
      const val = data._id;
      if (val === "LOADMORE") {
        this.loadMoreEntityData("LOADMORE");
      } else {
        this.globalFilter = val;
        this.loadMoreEntityData(val);
      }
      this.showGlobalFilterDropdown = false;
    },
    async fetchSubscriptionInfo() {
      let response = await axios.get("/getSubscriptionData");
      this.$store.commit(
        "paymentGateway/setSubscriptionPlanDetails",
        response.data.data,
        { root: true }
      );
    },
    onWorkspaceClear() {
      this.$nextTick(() => {
        this.currentWorkspaceId = this.lastSelectedWorkspaceId;
      });
    },
    onWorkspaceChange(val) {
      if (!val) return;
      this.currentWorkspaceId = val;
      this.ChangeAccount();
    },
    async getBotAccounts() {
      // this.loading = true;
      try {
        let response = await postAPICall("GET", "/bot/get-Bot");

        if (response && response.success && response.data?.chatBotDetails) {
          const botAccounts = response.data?.chatBotDetails || "";
          const botIdRegex = /botId: '(.*?)'/;
          const tokenRegex = /token: '(.*?)'/;
          const botIdMatch = botAccounts.match(botIdRegex);
          const tokenMatch = botAccounts.match(tokenRegex);

          if (botIdMatch && tokenMatch) {
            this.botId = botIdMatch[1];
            this.token = tokenMatch[1];
            localStorage.setItem("botId", this.botId);
            localStorage.setItem("token", this.token);

            const storedBotId = localStorage.getItem("botId");
            const storedToken = localStorage.getItem("token");

            if (storedBotId && storedToken) {
              window.bus.$emit("chatbot");
            } else {
              console.error("Failed to store botId or token in localStorage.");
            }
          } 
        } 
      } catch (error) {
        console.error("Chat bot", error);
      } finally {
        this.loading = false; 
      }
    },
    setPaymentsHistory() {
      if (this.getPaymentsHistory?.planFeatures?.length) {
        this.planDetails = this.getPaymentsHistory?.planFeatures?.[0];
        if (this.planDetails?.plan == 1 && this.planDetails?.diff) {
          this.getPermissionsListByCat();
        } else if (this.planDetails?.diff) {
          // Free Plan permissions
        } else {
          // expired
          if (
            [
              "/profile/subscription",
              "/plans-list",
              "/payments-status",
            ].includes(this.$route.path) ||
            [
              "subscription",
              "profile",
              "personal-information",
              "change-password",
              "signature",
            ].includes(this.$route.name)
          ) {
            //Subscription page
          } else {
            this.$router.push({
              path: `/expire?key=${
                Math.floor(Math.random() * (1000 - 1)) + 100
              }`,
            });
          }
        }
      }
      if (this.getPaymentsHistory?.planFeatures?.length) {
        let planDetails = this.getPaymentsHistory?.planFeatures?.[0];
        if (
          this.getUserType?.name == "OWNER" &&
          planDetails?.plan &&
          planDetails?.diff <= 5 &&
          planDetails?.diff > 0
        ) {
          this.$notify.warning({
            title: "Info",
            message: `Your plan is set to expire in  ${planDetails.diff} days. Don't miss out on our exclusive benefits`,
            showClose: false,
          });
        } else if (
          this.getUserType?.name == "OWNER" &&
          planDetails?.plan &&
          planDetails?.diff == 0
        ) {
          this.$notify.warning({
            title: "Info",
            message: `Your plan has expired`,
            showClose: false,
          });
        }
      }
    },
    async getNecessaryInfo() {
      this.loading = true;
      this.selectLoad = true;
      this.title = this.$route.meta.title || "Dashboard";
      let promises = [
        this.getPermissionsList(),
        this.fetchUserData(),
        this.getStyleForHorMenu(),
        this.fetchRolesList(),
        this.getSubscriptionHistory(),
        this.fetchSubscriptionInfo(),
      ];
      if (this.isWorkspaceIsBusiness) {
        if (!this.isIndividualWorkspace) {
          // await Promise.all([this.updateUserData(),this.getCompanyUserType(),this.getCompanyInfo()]);
          promises.push(this.getCompanyInfo(false));
        }
      }
      await Promise.all(promises);
      this.fetchNotifications();
      this.fetchAppNotifications();
      this.fetchChats();
      this.setActiveRole();
      this.getCompanyUserTypeList();
      this.getBotAccounts();
      this.fetchUserStatus();
      this.getCompanyConfigurationsList();
      if (!Object.keys(this.planDetails)?.length) {
        this.setPaymentsHistory();
      }
      bus.$on("workspaceList", (data) => {
        this.userWorkspaceList = data;
      });
      if (this.getSingleCompanyLogo) {
        this.logo = `${appConfig.S3_BUCKET_URL}/${this.getSingleCompanyLogo}`;
      }
      if (!this.brandingInfo?.is_menu_open) {
        this.$store.commit("navigationOpen/setIsOpen", false, {
          root: true,
        });
      }

      this.loading = false;
    },
    async getCompanyConfigurationsList() {
      this.loading = true;
      await this.$store.dispatch("UserIntegrations/fetchIntegrationsList");
      this.loading = false;
    },
    getEntityDataLabel(selectedEntity, item, i) {
      let name = "data " + i;
      if (selectedEntity && selectedEntity.primaryFields) {
        let primaryField = selectedEntity.primaryFields[0];
        let key =
          primaryField && primaryField["key"] ? primaryField["key"] : null;
        if (key) {
          name =
            item.entityData &&
            primaryField.template_id &&
            item.entityData[primaryField.template_id]
              ? item.entityData[primaryField.template_id][key + "/name"]
                ? item.entityData[primaryField.template_id][key + "/name"]
                : item.entityData[primaryField.template_id][key]
                ? primaryField.input_type == "DATE"
                  ? moment(
                      item.entityData[primaryField.template_id][key]
                    ).format(this.getDefaultDateFormat)
                  : primaryField.input_type == "DATE_TIME"
                  ? moment(
                      item.entityData[primaryField.template_id][
                        primaryField.key
                      ]
                    ).format(this.getDefaultDateFormat + " HH:mm:ss")
                  : item.entityData[primaryField.template_id][key]
                : "data" + i
              : "data" + i;
        }
      }
      return name;
    },
    loadMoreEntityData(value, query) {
      if (value == "LOADMORE") {
        this.globalFilter = "";
        this.globalFilterPage++;
        this.loadMore = true;
        this.fetchGlobalFilterEntityData();
      } else {
        this.$store.commit("auth/setGlobalFiltervalue", value, {
          root: true,
        });
        this.searchEntityData(query);
      }
    },
    searchEntityData(query) {
      if (query) {
        this.isSearching = true;
        if (query.length > 2) {
          this.globalFilterSearch = query;
          this.page = 1;
          this.fetchGlobalFilterEntityData();
        }
      } else {
        this.isSearching = false;
        this.globalFilterSearch = "";
        this.page = 1;
        this.fetchGlobalFilterEntityData();
      }
    },
    onIdle() {
      // alert('You have been logged out');
      let timerInterval;
      Swal.fire({
        title: "Session Timed Out",
        html: `Your session has been automatically logged out due to inactivity`,
        timer: 4000,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        didOpen: () => {
          Swal.showLoading();
        },
        willClose: () => {
          clearInterval(timerInterval);
          this.logout();
        },
      });
    },
    onRemind(time) {
      let timerInterval;
      Swal.fire({
        title: "",
        html: `Your session will automatically log out after ${time} seconds due to inactivity`,
        timer: 4000,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        didOpen: () => {
          Swal.showLoading();
        },
        willClose: () => {
          clearInterval(timerInterval);
          // this.logout();
        },
      });
    },
    async fetchRolesList() {
      if (this.getAuthenticatedUser && this.getAuthenticatedUser.roles) {
        this.assignedRoles = this.getAuthenticatedUser.roles;
      } else {
        this.assignedRoles = [];
      }
    },
    getLabel() {
      return (userType) => {
        if (userType && userType.role) {
          return userType.role.title + " - " + userType.name;
        } else {
          return userType.name;
        }
      };
    },

    ...mapActions({
      fetchUserStatus: "userStatus/fetchUserStatus",
      updateUserStatus: "userStatus/updateUserStatus",
      fetchNotifications: "dashboard/fetchNotifications",
      fetchChats: "dashboard/fetchChats",
      fetchPermissionList: "auth/getPermissions",
      fetchPermissions: "auth/updatePermissions",
      fetchAllAppNotifications: "appNotifications/fetchAllAppNotifications",
    }),
    handleCloseAllNotificationsPopup() {
      this.isViewAllNotificationsPopupShow = false;
      //no lines
    },
    async getPermissionsList() {
      this.loading = true;
      try {
        // await this.$store.dispatch("auth/getPermissions");
        if (this.getPermissionList) {
          this.permissionsList = this.getPermissionList;
        }
      } catch (err) {
        console.log("getPermissionsList", err);
      }
    },
    async getPermissionsListByCat() {
      try {
        let data = {
          categories: this.getPaymentsHistory.featuresList,
        };
        await this.$store.dispatch("auth/getPermissionsByCat", data);
        if (this.getPermissionList) {
          this.permissionsList = this.getPermissionList;
        }
        this.loagin = false;
      } catch (err) {
        console.log("getPermissionsListByCat", err);
      }
    },

    async goToChats(document_id, isChat = false) {
      if (isChat) {
        this.markAsReadChats({
          document_id,
        });
      }
      if (document) {
        if (document.document_status == "DRAFT") {
          this.$router.push({
            name: "employee-documents-custom-document-edit",
            params: {
              employee_document_id: document_id,
            },
          });
        } else {
          this.$router.push({
            name: "employee-documents-custom-document",
            params: {
              employee_document_id: document_id,
            },
            query: {
              tab: "chat",
            },
          });
        }
      }
    },
    async goToDocView(document) {
      if (
        document &&
        document.employee_document_id &&
        document.employee_document_id._id
      ) {
        this.markAsReadEachActivities(document._id);
        if (document) {
          if (document.document_status == "DRAFT") {
            this.$router.push({
              name: "employee-documents-custom-document-edit",
              params: {
                employee_document_id: document.employee_document_id._id,
              },
            });
          } else {
            this.$router.push({
              name: "employee-documents-custom-document",
              params: {
                employee_document_id: document.employee_document_id._id,
              },
              query: {
                tab: "logs",
              },
            });
          }
        }
      } else {
        this.$router.push({
          path: "/templates",
        });
      }
    },
    viewAllNotifications() {
      this.isViewAllNotificationsPopupShow = true;
      this.isNotificationPopupShow = false;
      document.body.className += " modal-open";
    },
    viewAllAppNotifications() {
      this.isViewAllAppNotificationsPopupShow = true;
      this.isAppNotificationPopupShow = false;
      document.body.className += " modal-open";
    },
    viewAllChats() {
      this.isViewAllChatsPopupShow = true;
      this.isChatPopupShow = false;
      document.body.className += " modal-open";
    },
    async toggleNotificationPopup() {
      if (this.getNotifications && !this.getNotifications.length) {
        this.$message.info("You have no notifications yet to display.");
      }
      this.isNotificationPopupShow = !this.isNotificationPopupShow;
      if (this.isNotificationPopupShow) {
        this.updateUserStatus({
          notification_last_open_date: "1",
        });
        this.fetchUserStatus();
      }
    },
    async toggleAppNotificationPopup() {
      this.isAppNotificationPopupShow = !this.isAppNotificationPopupShow;

      if (this.isAppNotificationPopupShow) {
        this.getIsOpen &&
          this.$store.commit("navigationOpen/setIsOpen", false, { root: true });
      }
      this.showGlobalFilterDropdown = false;
      this.showRoleDropdown = false;
      this.showWorkspaceDropdown = false;
      if (
        this.isAppNotificationPopupShow &&
        !this.allAppNotifications?.length
      ) {
        this.fetchAppNotifications();
      }
    },
    async fetchAppNotifications() {
      this.appNotificationsLoading = true;
      let params = {
        type: this.selectedNotificationType,
      };
      if (this.notification_search_string) {
        params["search_string"] = this.notification_search_string;
      }
      if (this.isUnreadOnly == "UNREAD") {
        params["is_read"] = false;
      }
      await this.fetchAllAppNotifications(params);
      if (this.getAllAppNotifications) {
        this.allAppNotifications = this.getAllAppNotifications.data;
        this.unreadNotificationsCount =
          this.getAllAppNotifications.unread_count;
        this.totalNotificationsCount =
          this.getAllAppNotifications.total_notifications_count;
        this.allNotificationsCount = this.getAllAppNotifications.total_count;
        this.totalUnreadNotificationsCount =
          this.getAllAppNotifications.total_unread_count;
      }
      this.totalPageLogs = 20;
      this.appNotificationsLoading = false;
    },
    async loadMoreLogs() {
      this.LoadMoreLoading = true;
      let params = {
        type: this.selectedNotificationType,
        skip: this.totalPageLogs,
        limit: 20,
        is_load_more: true,
      };
      if (this.notification_search_string) {
        params["search_string"] = this.notification_search_string;
      }
      if (this.isUnreadOnly == "UNREAD") {
        params["is_read"] = false;
      }
      await this.fetchAllAppNotifications(params);
      if (this.getAllAppNotifications) {
        this.totalPageLogs = this.totalPageLogs + 20;
        this.allAppNotifications = [
          ...this.allAppNotifications,
          ...this.getAllAppNotifications.data,
        ];
      }
      this.LoadMoreLoading = false;
    },
    async toggleChatPopup() {
      if (this.getChats && !this.getChats.length) {
        this.$message.info("You have no chats yet to display.");
      }
      this.isChatPopupShow = !this.isChatPopupShow;
      if (this.isChatPopupShow) {
        this.updateUserStatus({
          chat_last_open_date: "1",
        });
        this.fetchUserStatus();
      }
    },
    unmark(doc) {
      if (
        doc.sender_email &&
        doc.sender_email.email == this.getAuthenticatedUser.email &&
        doc.sender_email.is_read &&
        doc.sender_email.is_read == true
      ) {
        return doc.sender_email.is_read;
      } else {
        let user = doc.rec_email.find(
          (x) =>
            x.email && x.email == this.getAuthenticatedUser.email && x.is_read
        );
        return user;
      }
    },
    async markAsReadEachActivities(query = {}) {
      try {
        await axios.post("all-documents/mark-as-read-each-activities", {
          query,
        });
        if (this.getNotificationsUnReadCnt > 0) {
          await this.fetchNotifications();
        }
      } catch (err) {
        console.log("markAsReadActivities", err);
      }
    },
    async markAsReadActivities() {
      try {
        await axios.post("all-documents/mark-as-read-activities");
        await this.fetchNotifications();
        if (this.getNotificationsUnReadCnt > 0) {
          await this.fetchNotifications();
        } else {
          this.$message.warning("You don't have any unread Notifications");
        }
        this.isNotificationPopupShow = false; // Close the popup
      } catch (err) {
        console.log("markAsReadActivities", err);
      }
    },
    async markAsReadChats(query = {}) {
      try {
        await axios.post("all-documents/mark-as-read-notes", {
          query,
        });

        if (this.getChatsUnReadCnt > 0) {
          await this.fetchChats();
        } else {
          this.$message.warning("You don't have any unread Chats");
        }
        this.isChatPopupShow = false; // Close the popup
      } catch (err) {
        console.log("markAsReadChats", err);
      }
    },
    async markAppNotificationsAsReadChats() {
      if (this.unreadNotificationsCount) {
        await this.$store.dispatch("appNotifications/markAllAsRead", {
          type: this.selectedNotificationType,
        });
        if (this.getMarkAllAsReadStatus) {
          this.fetchAppNotifications();
        }
      } else {
        this.$message.warning("You don't have any unread Notifications");
      }
    },
    hideNotificationPopup() {
      this.isNotificationPopupShow = false;
    },
    hideAppNotificationPopup() {
      this.isAppNotificationPopupShow = false;
    },
    async handleNotificationClick(item) {
      if (!item.is_read) {
        this.totalUnreadNotificationsCount =
          this.totalUnreadNotificationsCount - 1;
      }
      let routerPath = "";
      let params = {
        id: item._id,
        data: {
          is_read: true,
        },
      };
      this.$store.dispatch("appNotifications/updateDataById", params);
      this.isAppNotificationPopupShow = false;
      let keyValue = Math.floor(Math.random() * 100000);
      switch (item.type) {
        case "ENTITY":
          switch (item.when) {
            case "ADDED":
            case "UPDATED":
              routerPath = `/entity/view/${item.entity_id._id}?key=${keyValue}&dataId=${item.entity_data_id}&filter=&layout=PROFILE&page=1&pageSize=10`;
              break;
            case "BULK_UPDATE":
              routerPath = `/entity/${item.entity_id._id}?key=${keyValue}`;
              break;
            default:
              routerPath = "";
          }
          break;
        case "FORM_BUILDER":
          switch (item.when) {
            case "FILLED":
            case "APPROVED":
            case "REJECTED":
              routerPath = `/fbd/${item.form_builder_id?.code}?key=${keyValue}`;
              break;
            default:
              routerPath = "";
          }
          break;
        case "NOTIFICATION":
          if (item.mail_sending_type == "ENTITY") {
            routerPath = `/entity/view/${item.entity_id._id}?key=${keyValue}&dataId=${item.entity_data_id}&filter=&layout=PROFILE&page=1&pageSize=10`;
          } else if (item.mail_sending_type == "FORM_BUILDER") {
            routerPath = `/fbd/${item.form_builder_id?.code}?key=${keyValue}`;
          }
          break;
        default:
          routerPath = "";
          break;
      }
      item.is_read = true;
      this.$router.push({
        path: routerPath,
      });
      // window.location.reload();
      //updateLogToRead and fetch again
      this.fetchAppNotifications();
    },
    getNotificationTypeAvatar(type) {
      let name = "";
      switch (type) {
        case "ENTITY":
          name = "EN";
          break;
        case "FORM_BUILDER":
          name = "FB";
          break;
        case "NOTIFICATION":
          name = "NF";
          break;
        case "OTHERS":
          name = "OT";
          break;
        default:
          name = "";
          break;
      }
      return name;
    },
    getAppNotificationDescription(item) {
      let description = "";
      switch (item.type) {
        case "ENTITY":
          switch (item.when) {
            case "ADDED":
              description = `A new entity data is <b>added</b> in <b>${item.entity_id?.name}</b>.`;
              break;
            case "UPDATED":
              description = `An entity data is <b>updated</b> in <b>${item.entity_id?.name}</b>.`;
              break;
            case "DELETED":
              description = `A entity data is <b>deleted</b> in <b>${item.entity_id?.name}</b>.`;
              break;
            case "BULK_UPDATE":
              description = `Bulk update was performed in <b>${item.entity_id?.name}</b>.`;
              break;
            default:
              description = "Action in Entity";
              break;
          }
          break;
        case "FORM_BUILDER":
          switch (item.when) {
            case "FILLED":
              description = `A new form data is <b>filled</b> in <b>${item.form_builder_id?.name}</b>`;
              break;
            case "APPROVED":
              description = `A form data is <b>approved</b> by <span style="color: #409eff">${item.user_details.name}</span> in <b>${item.form_builder_id?.name}</b>`;
              break;
            case "REJECTED":
              description = `A form is <b>rejected</b> by <span style="color: #409eff">${item.user_details.name}</span> in <b>${item.form_builder_id?.name}</b>`;
              break;
            default:
              description = "Action in Form Builder";
              break;
          }
          break;
        case "NOTIFICATION":
          if (item.entity_data_id && item.entity_data_id) {
            description = `Email successfully sent to an entity data in <b>${item.entity_id?.name}</b>.`;
          } else if (item.form_builder_data_id) {
            description = `Email successfully sent to a form data in <b>${item.form_builder_id?.name}</b>.`;
          }
          break;
        default:
          description = "";
          break;
      }
      return description;
    },
    hideChatPopup() {
      this.isChatPopupShow = false;
    },
    sendMessageToParent() {
      this.$store.commit("navigationOpen/setIsOpen", !this.getIsOpen, {
        root: true,
      });
      this.$emit("open:sidebar", !this.isOpen);
    },
    async fetchUserData() {
      if (this.getActiveWorkspace) {
        this.currentWorkspace = this.getActiveWorkspace;
        this.currentWorkspaceId = this.currentWorkspace.company_id;
        this.userWorkspaceList = this.getWorkspaceList.filter(
          (e) => e?.company_id?._id
        );

        let info = await this.updateIndividualWorkspace(
          this.getActiveWorkspace
        );
        this.currentWorkspace = info.currentWorkspace;
        this.userWorkspaceList = info.userWorkspaceList.filter(
          (e) => e?.company_id?._id
        );

        this.selectLoad = false;
      } else {
        await this.handleLogoutInfo();
      }
    },
    async updateUserData() {
      this.loading = true;
      await this.$store.dispatch(
        "auth/fetchUsersWithEmail",
        this.getAuthenticatedUser.email
      );
      if (this.getWorkspaceList) {
        let info = await this.updateIndividualWorkspace(
          this.getActiveWorkspace
        );
        this.currentWorkspace = info.currentWorkspace;
        this.userWorkspaceList = info.userWorkspaceList.filter(
          (e) => e?.company_id?._id
        );
      } else {
        this.userWorkspaceList = [];
      }
    },
    async changeRole() {
      this.loading = true;
      let timerInterval;
      Swal.fire({
        title: "",
        html: "Validation process is going on.It will take few seconds.Please wait....",
        timer: 15000,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        didOpen: () => {
          Swal.showLoading();
        },
        willClose: () => {
          clearInterval(timerInterval);
        },
      });
      await this.$store.dispatch(
        "auth/fetchUsersWithEmail",
        this.getAuthenticatedUser.email
      );

      if (this.getWorkspaceList) {
        let presentWorkSpace = this.getWorkspaceList.filter((u) => {
          if (
            u.company_id == this.currentWorkspace.company_id ||
            u.company_id._id == this.currentWorkspace.company_id
          ) {
            return u;
          }
        });
        let selectedWorkSpace = this.getWorkspaceList.filter((u) => {
          if (
            u.company_id == this.currentWorkspaceId ||
            u.company_id._id == this.currentWorkspaceId
          ) {
            return u;
          }
        });
        if (
          presentWorkSpace &&
          presentWorkSpace.length &&
          presentWorkSpace[0] &&
          presentWorkSpace[0].status === "ACTIVE"
        ) {
          if (selectedWorkSpace && selectedWorkSpace.length) {
            if (
              selectedWorkSpace[0] &&
              selectedWorkSpace[0].status === "ACTIVE"
            ) {
              Swal.close();
              await this.changeWorkspaceRole(
                this.currentWorkspaceId,
                this.activeRole
              );
            } else if (
              selectedWorkSpace[0] &&
              selectedWorkSpace[0].status === "HOLD"
            ) {
              Swal.close();
              await this.activateAccount();
            } else if (
              selectedWorkSpace[0] &&
              selectedWorkSpace[0].status === "INACTIVE"
            ) {
              await this.revertOldWorkspace(
                "This workspace is in inactive state. Please contact administrator"
              );
            } else {
              await this.revertOldWorkspace(
                "This workspace is not found in your records . Please verify once "
              );
            }
          } else {
            await this.revertOldWorkspace(
              "This workspace is not found in your records . Please verify once "
            );
          }
        } else if (
          presentWorkSpace &&
          presentWorkSpace.length &&
          presentWorkSpace[0] &&
          presentWorkSpace[0].status === "HOLD"
        ) {
          await this.handleLogoutInfo(
            "This workspace is in Hold state. Please contact to  administrator.Please re-login."
          );
        } else if (
          presentWorkSpace &&
          presentWorkSpace.length &&
          presentWorkSpace[0] &&
          presentWorkSpace[0].status === "INACTIVE"
        ) {
          await this.handleLogoutInfo(
            "This workspace is in inactive state. Please contact to administrator.Please re-login."
          );
        }
      }
    },

    async ChangeAccount() {
      this.loadingText = "Checking for access...";
      this.loading = true;
      let timerInterval;
      Swal.fire({
        title: "",
        html: "Validation process is going on.It will take few seconds.Please wait....",
        timer: 15000,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        didOpen: () => {
          Swal.showLoading();
        },
        willClose: () => {
          clearInterval(timerInterval);
        },
      });
      await this.$store.dispatch(
        "auth/fetchUsersWithEmail",
        this.getAuthenticatedUser.email
      );

      if (this.getWorkspaceList) {
        let presentWorkSpace = this.getWorkspaceList.filter((u) => {
          if (
            u.company_id == this.currentWorkspace.company_id ||
            u.company_id?._id == this.currentWorkspace.company_id
          ) {
            return u;
          }
        });
        let selectedWorkSpace = this.getWorkspaceList.filter((u) => {
          if (
            u.company_id == this.currentWorkspaceId ||
            u.company_id._id == this.currentWorkspaceId
          ) {
            return u;
          }
        });
        if (
          presentWorkSpace &&
          presentWorkSpace.length &&
          presentWorkSpace[0] &&
          presentWorkSpace[0].status === "ACTIVE"
        ) {
          if (selectedWorkSpace && selectedWorkSpace.length) {
            if (
              selectedWorkSpace[0] &&
              selectedWorkSpace[0].status === "ACTIVE"
            ) {
              Swal.close();
              await this.changeWorkspace(this.currentWorkspaceId, true);
              this.loading = false;
            } else if (
              selectedWorkSpace[0] &&
              selectedWorkSpace[0].status === "HOLD"
            ) {
              Swal.close();
              await this.activateAccount();
              this.loading = false;
            } else if (
              selectedWorkSpace[0] &&
              selectedWorkSpace[0].status === "INACTIVE"
            ) {
              await this.revertOldWorkspace(
                "This workspace is in inactive state. Please contact administrator"
              );
            } else {
              await this.revertOldWorkspace(
                "This workspace is not found in your records . Please verify once "
              );
            }
          } else {
            await this.revertOldWorkspace(
              "This workspace is not found in your records . Please verify once "
            );
          }
        } else if (
          presentWorkSpace &&
          presentWorkSpace.length &&
          presentWorkSpace[0] &&
          presentWorkSpace[0].status === "HOLD"
        ) {
          await this.handleLogoutInfo(
            "This workspace is in Hold state. Please contact to  administrator.Please re-login."
          );
        } else if (
          presentWorkSpace &&
          presentWorkSpace.length &&
          presentWorkSpace[0] &&
          presentWorkSpace[0].status === "INACTIVE"
        ) {
          await this.handleLogoutInfo(
            "This workspace is in inactive state. Please contact to administrator.Please re-login."
          );
        }
      }
      this.loading = false;
    },
    async activateAccount() {
      this.loading = false;
      Swal.close();
      Swal.fire({
        title: "Are you sure?",
        text: "This workspace is in hold state. Do you want to activate it?",
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.loadingText = "activating your workspace";
          this.loading = true;
          try {
            await this.$store.dispatch(
              "auth/verifyAndSwitch",
              this.currentWorkspaceId
            );
            if (this.getAuthenticationStatus) {
              this.loading = false;
              Swal.close();
              await this.changeWorkspace(this.currentWorkspaceId);
            } else {
              await this.revertOldWorkspace("Failed to active the account");
            }
          } catch (HoldError) {
            console.log("activeAccount", HoldError);
            Swal.close();
            await this.revertOldWorkspace("");
          }
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          this.currentWorkspaceId = this.currentWorkspace.company_id;
        }
      });
    },

    async revertOldWorkspace(msg = "") {
      this.loading = false;
      Swal.close();
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: msg ? msg : "Something went wrong!",
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.currentWorkspaceId = this.currentWorkspace.company_id;
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          this.currentWorkspaceId = this.currentWorkspace.company_id;
        }
      });
    },
    loadComponent(value, text) {
      console.log({ value, text });
      this.loadingText = text || "Switching your workspace...";
      this.loading = value;
    },
    async loadingAlert() {
      this.loadingText = "Switching your workspace...";
      this.loading = true;
      Swal.close();
      // let timerInterval;
      // Swal.fire({
      //   title: "",
      //   html: "Please wait....",
      //   timer: timer,
      //   allowOutsideClick: false,
      //   allowEscapeKey: false,
      //   allowEnterKey: false,
      //   didOpen: () => {
      //     Swal.showLoading();
      //   },
      //   willClose: () => {
      //     clearInterval(timerInterval);
      //   },
      // });
    },
    async getCompanyUserTypeList() {
      if (this.getActiveWorkspace && this.getActiveWorkspace?.company_id) {
        try {
          this.userTypes = await fetchUserTypes();
          this.getUserTypeEmailsList(this.userTypes);
        } catch (err) {
          this.$notify.error({
            title: "Error",
            message: err,
          });
        }
      }
    },
  },
  created() {
    this.lastSelectedWorkspaceId = this.getActiveWorkspace.company_id;
    this.$bus.$on("load-component", this.loadComponent);
    this.$bus.$on(
      "fetch-global-filter-entity-data",
      this.fetchGlobalFilterEntityData
    );
  },
  beforeDestroy() {
    this.$bus.$off("load-component", this.loadComponent);
    this.$bus.$off(
      "fetch-global-filter-entity-data",
      this.fetchGlobalFilterEntityData
    );
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>
<style scoped>
/* Top Navigation Bar Styles */
.top-navbar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  padding: 6px 12px;
  background-color: #1b487e;
  border-top: 1px solid #ddd;
  min-height: 60px;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}

/* Footer Menu Container */
.logout-dropdown {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0;
  margin: 0;
  list-style: none;
}

/* Each Footer Menu Item */
.logout-dropdown li {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  position: relative;
}

/* Icon + Label Wrapper */
.icon-wrapper,
.notification-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 12px;
  width: 100%;
}

/* Circular Icon Box */
.icon-block {
  display: flex;
  align-items: center;
  justify-content: center;
  /* background: #2c3e50; */
  border-radius: 50%;
  width: 40px;
  height: 40px;
  color: #fff;
}

/* Icon Styling */
.fa.icon,
.el-icon-back,
.el-icon-chat-dot-square {
  font-size: 24px;
}

/* Icon Label */
.icon-label {
  margin-top: 5px;
  font-size: 11px;
  text-align: center;
  color: white;
}

/* Hamburger Circle Button */
.circle-outline-hamburger {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid white;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 0;
  margin: 0 auto;
}

.circle-outline-hamburger:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

/* Hamburger Lines */

.burger-bar {
  background-color: white;
  height: 2px;
  width: 18px;
  border-radius: 1px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.burger-bar--1 {
  top: 10px;
}
.burger-bar--2 {
  top: 18px;
}
.burger-bar--3 {
  top: 26px;
}

#burger.active .burger-bar--1 {
  transform: translateX(-50%) rotate(45deg);
}
#burger.active .burger-bar--2 {
  opacity: 0;
}
#burger.active .burger-bar--3 {
  transform: translateX(-50%) rotate(-45deg);
}

/* Chat Icon Adjustments */
.chat-icon {
  margin-left: 10px;
}

/* Responsive Enhancements */
@media (max-width: 768px) {
  .icon-block {
    width: 36px;
    height: 36px;
  }

  .icon-label {
    font-size: 10px;
  }

  .fa.icon,
  .el-icon-back,
  .el-icon-chat-dot-square {
    font-size: 24px;
  }

  .circle-outline-hamburger {
    width: 36px;
    height: 36px;
  }

  .burger-bar {
    width: 16px;
  }
}

@media (max-width: 480px) {
  .icon-block {
    width: 32px;
    height: 32px;
  }

  .icon-label {
    font-size: 10px;
  }

  .fa.icon {
    font-size: 24px;
  }
}

.badge-notification {
  position: absolute;
  top: -6px;
  right: -6px;
  background: #f754a2;
  color: #fff;
  font-size: 10px;
  padding: 2px 5px;
  border-radius: 10px;
  line-height: 1;
  font-weight: bold;
  min-width: 16px;
  text-align: center;
  z-index: 1;
  pointer-events: none;
}

.notification-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.popup-header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 50px;
  background: #1b487e;
  color: white;
  font-weight: bold;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  z-index: 1;
}

.notification-count {
  display: flex;
  justify-content: center;
  font-weight: 500;
  margin-bottom: 8px;
}

.notification-popup {
  position: fixed;
  bottom: 60px;
  right: 10px;
  width: 340px;
  max-height: 80vh;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  overflow: hidden;
  z-index: 3000;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;
}

.notification-popup2 {
  right: 70px;
}

.mobile-column {
  right: 10px;
  left: 10px;
  width: auto;
  max-width: 100%;
  border-radius: 12px;
  bottom: 70px;
}

/* Inner Scrollable List */
.notification-popup .el-scrollbar {
  flex: 1;
  overflow-y: auto;
}

/* Notification Item */
.notifcation-item {
  display: flex;
  padding: 10px 15px;
  align-items: center;
  border-bottom: 1px solid #eee;
}

.notifcation-item:hover {
  background-color: #f9f9f9;
  cursor: pointer;
}

.item-avatar {
  width: 36px;
  height: 36px;
  background: #409eff;
  color: white;
  border-radius: 50%;
  text-align: center;
  line-height: 36px;
  font-weight: bold;
  margin-right: 12px;
  font-size: 14px;
}

.item-body {
  flex: 1;
}

.notification-line .message {
  font-size: 13px;
  color: #333;
}

.date-time {
  font-size: 11px;
  color: #999;
  margin-top: 2px;
  display: block;
}

.load-more-element {
  text-align: center;
  padding: 10px;
  background: #f4f4f4;
  cursor: pointer;
  font-weight: 500;
  color: #409eff;
}

.load-more-element:hover {
  background: #ebf5ff;
}
.notification-popup {
  backdrop-filter: blur(8px);
}

.notification-popup {
  animation: slideUp 0.3s ease-out;
}
@keyframes slideUp {
  from {
    transform: translateY(40px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.close-btn {
  background: transparent;
  border: none;
  font-size: 22px;
  color: black;
  cursor: pointer;
}
</style>
